import { render, staticRenderFns } from "./slider-item-boxer.vue?vue&type=template&id=5b02b38f&scoped=true&"
import script from "./slider-item-boxer.vue?vue&type=script&lang=js&"
export * from "./slider-item-boxer.vue?vue&type=script&lang=js&"
import style0 from "./slider-item-boxer.vue?vue&type=style&index=0&id=5b02b38f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b02b38f",
  null
  
)

export default component.exports